import { Target } from '@cbhq/identity-shared/types';
import { createWrappedPromise, WrappedPromise } from '@cbhq/identity-shared/utils';

import { Fingerprint, InitConfig } from './types';

type InitTiming = {
  sdkLoadTime?: number;
};

type IdentityFingerprintStore = {
  initConfig: InitConfig | undefined;
  deviceIdPromise: WrappedPromise<string | undefined>;
  fingerprintPromise: WrappedPromise<Fingerprint | undefined>;
  timing: InitTiming;
};

export const mapTargetToFingerprintProSealedApiKey: Record<Target, string> = {
  production: 'QdZg09cwtZapmMeSKXKw',
  staging: '4QLftGzv35DNX1twb3gD',
  development: '4QLftGzv35DNX1twb3gD',
  local: '4QLftGzv35DNX1twb3gD',
  mock: '4QLftGzv35DNX1twb3gD',
};

export const fingerprintStore: IdentityFingerprintStore = {
  initConfig: undefined as InitConfig | undefined,
  /**
   * We use this promise to store the device ID
   * Whenever getDeviceID is called, we return this promise.
   * The promise is resolved by the initIdentityFingerprint function.
   */
  deviceIdPromise: createWrappedPromise<string | undefined>(),
  /**
   * We use this promise to store the sealed fingerprint
   * Whenever getFingerprint is called, we return this promise.
   * The promise is initialized and resolved by the initIdentityFingerprint function.
   */
  fingerprintPromise: createWrappedPromise<Fingerprint | undefined>(),
  timing: {
    sdkLoadTime: undefined, // Will be set when SDK actually loads
  },
};
